import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Faq from "./sections/Faq";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Faq />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}